module.exports = __webpack_public_path__ + "static/img/bank-quankuan.0825bac6.png";